<div class="dialog">
    <div [ngSwitch]="data.type">
        <div *ngSwitchCase="TaggingValidationType.DUPLICATED_ITEM_SET">
            <h1 mat-dialog-title class="dialog-title">Duplicated Item Set</h1>
            <div mat-dialog-content class="dialog-content">
                <p>The set of items you are trying to tag already exist. Please update that set separately.</p>
                <div class="field-row">
                    <p class="field-label">Item no:</p>
                    <p>{{data.conflictingTaggedGroups?.[0]?.itemNumbers?.join(", ")}}</p>
                </div>
                <div class="field-row">
                    <p class="field-label">Vendors:</p>
                    <p>{{concatVendorElement('vendorName', data.conflictingTaggedGroups?.[0]?.vendors)}}</p>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="cancelButtonTemplate"></ng-container>
        </div>
        <div *ngSwitchCase="TaggingValidationType.PURCHASE_EXECUTIVE_TAG_CONFLICT">
            <h1 mat-dialog-title class="dialog-title">Purchase Executive Tag Conflict</h1>
            <div mat-dialog-content class="dialog-content">
                <p>The set of vendors you are trying to tag is currently assigned to another set of items managed by
                    another Purchasing Executive. Please coordinate offline to resolve this conflict.</p>
                <div class="field-row">
                    <p class="field-label">Item no:</p>
                    <p>{{data.conflictingTaggedGroups?.[0]?.itemNumbers?.join(", ")}}</p>
                </div>
                <div class="field-row">
                    <p class="field-label">Vendors:</p>
                    <p>{{concatVendorElement('vendorName', data.conflictingTaggedGroups?.[0]?.vendors)}}</p>
                </div>
                <div class="field-row">
                    <p class="field-label">Tagged By:</p>
                    <p>{{ getUserDisplayName(data.conflictingTaggedGroups?.[0]?.purchaseExecutive)}}</p>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="cancelButtonTemplate"></ng-container>
        </div>
        <div *ngSwitchCase="TaggingValidationType.DUPLICATED_VENDOR_SET">
            <h1 mat-dialog-title class="dialog-title">Duplicated Vendor Set</h1>
            <div mat-dialog-content class="dialog-content">
                <p>The vendor set you are trying to tag to already exist.</p>
                <div class="field-row">
                    <p class="field-label">Item no:</p>
                    <p>{{data.conflictingTaggedGroups?.[0]?.itemNumbers?.join(", ")}}</p>
                </div>
                <div class="field-row">
                    <p class="field-label">Vendors:</p>
                    <p>{{concatVendorElement('vendorName', data.conflictingTaggedGroups?.[0]?.vendors)}}</p>
                </div>
                <div>
                    <p class="mb-1 mt-2">Do you want to merge with or replace the existing vendor set?</p>
                    <mat-button-toggle-group name="choice" [(ngModel)]="formData.choice"
                        aria-label="Conflict resolution choice" appearance="standard">
                        <mat-button-toggle [value]="TaggingResolutionChoice.MERGE">Merge</mat-button-toggle>
                        <mat-button-toggle [value]="TaggingResolutionChoice.REPLACE">Replace</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="cancelConfirmButtonsTemplate"></ng-container>
        </div>
        <div *ngSwitchCase="TaggingValidationType.EXISTING_VENDOR_TAGGED">
            <h1 mat-dialog-title class="dialog-title">Existing Tagged Item-Vendor</h1>
            <div mat-dialog-content class="dialog-content">
                <p>The items you are trying to tag to no vendors have existing vendor associations in other records. By
                    doing so, these affected items will be removed from all records linked to other vendors.
                </p>
                <p>Confirm this action? This cannot be undone.</p>
                <div class="field-row">
                    <p class="field-label">Affected Item no:</p>
                    <p>{{data.displayAffected}}</p>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="cancelConfirmButtonsTemplate"></ng-container>
        </div>
        <div *ngSwitchCase="TaggingValidationType.REASSIGNMENT_UNSAVED_TAG">
            <h1 mat-dialog-title class="dialog-title">Unsaved Tagging Changes</h1>
            <div mat-dialog-content class="dialog-content">
                <p>Please save your tagging changes before transferring or taking over any item task.</p>
            </div>
            <ng-container *ngTemplateOutlet="cancelButtonTemplate"></ng-container>
        </div>
        <div *ngSwitchCase="TaggingValidationType.DELETE_VENDOR_OWN_TAG_CONFLICT">
            <h1 mat-dialog-title class="dialog-title">Unable to delete vendor</h1>
            <div mat-dialog-content class="dialog-content">
                <p>The vendor you are trying to delete is currently assigned to set(s) of items created by yourself.
                    Please go to 'Item-Vendor Tagging' tab to remove this vendor from all sets before deleting it from
                    this tab.</p>
            </div>
            <ng-container *ngTemplateOutlet="cancelButtonTemplate"></ng-container>
        </div>
        <div *ngSwitchCase="TaggingValidationType.DELETE_VENDOR_OTHER_PURCHASE_EXECUTIVE_TAG_CONFLICT">
            <h1 mat-dialog-title class="dialog-title">Unable to delete vendor</h1>
            <div mat-dialog-content class="dialog-content">
                <p>The vendor you are trying to delete is currently assigned to set(s) of items managed by another
                    Purchasing Executive. Please coordinate offline to remove this vendor from all sets before deleting
                    it from this tab.</p>
            </div>
            <ng-container *ngTemplateOutlet="cancelButtonTemplate"></ng-container>
        </div>
    </div>

    <ng-template #cancelButtonTemplate>
        <div mat-dialog-actions class="dialog-buttons">
            <app-button class="padBtn cancelBtn" name="Cancel" mat-dialog-close></app-button>
        </div>
    </ng-template>

    <ng-template #cancelConfirmButtonsTemplate>
        <div mat-dialog-actions class="dialog-buttons">
            <app-button class="padBtn cancelBtn" name="Cancel" mat-dialog-close></app-button>
            <app-button class="padBtn actionBtn" name="Confirm" type="flat-button" cdkFocusInitial
                (click)="onDialogAction()"></app-button>
        </div>
    </ng-template>

</div>